import { createContext } from 'react';
import { Record } from 'immutable';
export const SubjectData = Record({
  objectType: undefined,
  subjectId: ''
});
export const SubjectContext = /*#__PURE__*/createContext(null);